import { render } from "./exercieseItem.vue?vue&type=template&id=0cd24f1b&scoped=true&ts=true"
import script from "./exercieseItem.vue?vue&type=script&lang=ts"
export * from "./exercieseItem.vue?vue&type=script&lang=ts"

import "./exercieseItem.vue?vue&type=style&index=0&id=0cd24f1b&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd24f1b"]])

export default __exports__